import React from "react";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Contact Enerflo";

const MainHero = () => (
  <HeroSection title={title} className="pb-0 sm:pb-0 lg:pb-0">
    <div className="flex-grow">
      <HeroSection.Content className="mx-auto md:w-3/4 md:text-center lg:w-3/5">
        <HeroSection.Header>
          <Heading tag="h1">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          We want to hear from you! Interested in seeing a demo? Have a question? Want to share deep thoughts on solar?
          Want to join our team? We’re up for all of it.
        </HeroSection.Description>
      </HeroSection.Content>
    </div>
  </HeroSection>
);

export default MainHero;
